const Gvt = {
  symbol: 'gvt',
  color: '#000',
  colorIcon() {
    return `<g fill="none" fill-rule="evenodd"><circle cx="16" cy="16" fill="#16b9ad" r="16"/><path d="M26 13.193C26 18.601 21.513 23 16 23S6 18.6 6 13.195c0-.398.024-.797.074-1.193H7.87c-.06.395-.09.794-.09 1.193 0 4.445 3.688 8.062 8.221 8.062 4.326 0 7.882-3.292 8.2-7.455H11.48c.27 1.944 1.803 3.488 3.777 3.807 1.975.318 3.93-.664 4.822-2.42h1.925c-.875 2.522-3.29 4.218-6.006 4.22-3.496 0-6.341-2.789-6.341-6.216 0-.4.04-.8.117-1.193h16.152c.05.396.074.794.074 1.193z" fill="#fff" fill-rule="nonzero"/></g>`;
  },
  plainIcon: c => {
    return `<path fill-rule="evenodd" fill="${
      c ? c : this.color
    }" d="M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm10-18.807c0-.399-.024-.797-.074-1.193H9.774a6.112 6.112 0 00-.117 1.193c0 3.427 2.845 6.217 6.34 6.217 2.718-.003 5.132-1.7 6.007-4.221H20.08c-.891 1.756-2.847 2.738-4.822 2.42-1.974-.319-3.506-1.863-3.777-3.807h12.721c-.317 4.163-3.873 7.455-8.199 7.455-4.533 0-8.221-3.617-8.221-8.062 0-.399.03-.798.09-1.193H6.074c-.05.396-.074.795-.074 1.193C6 18.601 10.487 23 16 23s10-4.4 10-9.807z" fill-rule="evenodd"/>`;
  }
};
export default Gvt;
